import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-ble-slide',
  templateUrl: './ble-slide.component.html',
  styleUrls: ['./ble-slide.component.scss']
})
export class BleSlideComponent implements OnInit {

  @Input() valore?: boolean;
  @Input() testo?: string;
  @Input() block?: boolean;
  @Input() invalid ? = false;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';

  @Output() cambioValore = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  valueChange(evt: boolean) {
    // this.valore = evt;
    this.cambioValore.emit(evt);
  }

}
